import { render, staticRenderFns } from "./BuyerVoucher.vue?vue&type=template&id=b56418e8&scoped=true"
import script from "./BuyerVoucher.vue?vue&type=script&lang=js"
export * from "./BuyerVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56418e8",
  null
  
)

export default component.exports